import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './style.scss';

interface LoadingIndicatorProps {
  isLoading: boolean;
  fullScreen?: boolean;
}

const LoadingIndicator = ({ isLoading, fullScreen = false }: LoadingIndicatorProps) => (
  <div
    className={'loading-indicator' + (fullScreen ? ' fullscreen' : '')}
    style={{
      display: isLoading ? 'flex' : 'none',
    }}
  >
    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
  </div>
);

LoadingIndicator.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  fullScreen: PropTypes.any,
};

export default LoadingIndicator;
